import React from 'react';
import { 
  FaHandHoldingUsd, FaUserTie, FaCar, FaHeadset,
  FaCheckCircle, FaCrown, FaArrowRight
} from 'react-icons/fa';
import '../style.css';

const DrivenbyPerfection = () => {
  const services = [
    {
      icon: <FaHandHoldingUsd />,
      title: "Affordable Fares",
      subtitle: "Transparent Pricing",
      description: "No hidden charges, luxury at value. Experience premium travel without the premium price tag.",
      color: "#FF6B35",
      features: ["No Hidden Charges", "Best Price Guarantee", "Flexible Payment"]
    },
    {
      icon: <FaUserTie />,
      title: "Elite Drivers",
      subtitle: "Professional & Knowledgeable",
      description: "Professional, polite, and deeply knowledgeable about Kashi's spiritual and cultural heritage.",
      color: "#1A73E8",
      features: ["Local Experts", "Multi-lingual", "Safety Certified"]
    },
    {
      icon: <FaCar />,
      title: "Elite Cab",
      subtitle: "Modern Fleet",
      description: "Pristine sedans to luxury SUVs, maintained to the highest standards of cleanliness and comfort.",
      color: "#2ECC71",
      features: ["Regular Sanitization", "Premium Comfort", "Latest Models"]
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Concierge",
      subtitle: "Round-the-Clock Support",
      description: "24/7 booking support and instant trip confirmation. Your journey, our priority.",
      color: "#9B59B6",
      features: ["Instant Booking", "Multi-language", "Personalized Service"]
    }
  ];

  return (
    <section className="luxury-services">
      <div className="luxury-container">
        {/* Header */}
        <div className="luxury-header">
          <div className="luxury-badge">
            <FaCrown />
            <span>Premium Services</span>
          </div>
          <h1 className="luxury-title">Experience Premium Travel</h1>
          <p className="luxury-description">
            Discover our exclusive range of luxury cab services designed for ultimate comfort and convenience.
          </p>
        </div>

        {/* Services Grid */}
        <div className="luxury-grid">
          {services.map((service, index) => (
            <div key={index} className="luxury-card">
              <div className="card-header">
                <div 
                  className="card-icon-wrapper"
                  style={{ backgroundColor: service.color }}
                >
                  {service.icon}
                </div>
                <div className="card-title-wrapper">
                  <h3 className="card-title">{service.title}</h3>
                  <p className="card-subtitle">{service.subtitle}</p>
                </div>
              </div>

              <div className="card-body">
                <p className="card-text">{service.description}</p>
                
                <div className="features-wrapper">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="feature">
                      <FaCheckCircle style={{ color: service.color }} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                <button 
                  className="cta-button"
                  style={{ 
                    backgroundColor: service.color,
                    borderColor: service.color
                  }}
                >
                  <span>Learn More</span>
                  <FaArrowRight />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DrivenbyPerfection;